  <div class="iframe-container" *ngIf="isLoaded">
    <iframe  #iframe [src]="webUrl" frameborder="0" allowfullscreen ></iframe>
   </div>
